export default __webpack_public_path__ + "static/media/land-2.cb43deb7.mp4";